interface WatermarkOverlayProps {
  text: string;
  /** 深色背景模式（视频播放器等），默认 false */
  dark?: boolean;
}

export default function WatermarkOverlay({ text, dark = false }: WatermarkOverlayProps) {
  const rows = 4;
  const cols = 3;

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden select-none z-10">
      {Array.from({ length: rows }).map((_, r) =>
        Array.from({ length: cols }).map((_, c) => (
          <div
            key={`${r}-${c}`}
            className="absolute font-mono whitespace-nowrap"
            style={{
              fontSize: '26px',
              fontWeight: 500,
              color: dark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)',
              transform: 'rotate(-35deg)',
              left: `${(c / cols) * 100}%`,
              top: `${(r / rows) * 100}%`,
              letterSpacing: '0.4px',
            }}
          >
            {text}
          </div>
        ))
      )}
    </div>
  );
}
